// extracted by mini-css-extract-plugin
export default {"navItem":"NavItem_navItem__4ziRP","navItemIcon":"NavItem_navItemIcon__YVqv+","navItemLabel":"NavItem_navItemLabel__AydEo"};